import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_EXAMINATION, CREATING_EXAMINATION, EXAMINATIONS_ERROR, GETTING_EXAMINATIONS, GET_EXAMINATIONS, UPDATE_EXAMINATION, UPDATING_EXAMINATION } from "../types"

export const createExamination = (documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_EXAMINATION,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/examinations`, documentRequestPayload, { headers })
        
        dispatch({
            type: CREATE_EXAMINATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: EXAMINATIONS_ERROR,
            error
        })
    }
}

export const updateExamination = (examinationId, examinationPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_EXAMINATION,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/examinations/${examinationId}`, examinationPayload, { headers })
        
        dispatch({
            type: UPDATE_EXAMINATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: EXAMINATIONS_ERROR,
            error
        })
    }
}

export const fetchExaminations = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/examinations?expand=fee,location`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_EXAMINATIONS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_EXAMINATIONS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: EXAMINATIONS_ERROR,
            error
        })
    }
}

export const clearCreatedExamination = () => async (dispatch) => {    
    dispatch({
        type: CREATE_EXAMINATION,
        payload: null
    })   
}

export const clearUpdatedExamination = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_EXAMINATION,
        payload: null
    })   
}